import { render, staticRenderFns } from "./TableCodeComponent.vue?vue&type=template&id=23650c3d&scoped=true&"
import script from "./TableCodeComponent.vue?vue&type=script&lang=js&"
export * from "./TableCodeComponent.vue?vue&type=script&lang=js&"
import style0 from "./TableCodeComponent.vue?vue&type=style&index=0&id=23650c3d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23650c3d",
  null
  
)

export default component.exports